module.exports = __webpack_public_path__ + "img/cancercouncil-wa.2415062.png";